export default class FinesseSidebarButton extends HTMLElement {
  active: boolean = false
  button: HTMLElement | null = null
  menuIcon: HTMLElement | null = null
  closeIcon: HTMLElement | null = null

  static get observedAttributes() {
    return ['active']
  }

  constructor() {
    super()

    this.button = this.querySelector<HTMLElement>('a[data-sidebar-button]') as HTMLElement
    this.menuIcon = this.querySelector<HTMLElement>('span[data-menu-icon]') as HTMLElement
    this.closeIcon = this.querySelector<HTMLElement>('span[data-close-icon]') as HTMLElement

    (window as any).addEventListener('sidebar:toggle', this.handleCart.bind(this))
    this.button.addEventListener('mouseenter', this.handleEnter.bind(this))
    this.button.addEventListener('click', this.handleClick.bind(this))

    // unhide the menu icon on mobile
    if (window.innerWidth < 769) {
      this.menuIcon?.classList.remove('hidden')
    }
  }
  
  get isActive() {
    return this.active
  }

  set isActive(value: boolean) {
    this.active = value
    this.setAttribute('active', value.toString())
    this.toggle()
  }

  handleCart(evt: CustomEvent) {
    // @ts-ignore
    this.isActive = evt.detail.active
  }

  handleEnter(evt: Event) {
    const isMobile = window.innerWidth < 769

    if (!isMobile) {
      evt.preventDefault()

      window.dispatchEvent(new CustomEvent('sidebar:toggle', { bubbles: true, detail: { active: true } }))
    }
  }

  handleClick(evt: Event) {
    const isMobile = window.innerWidth < 769

    if (isMobile) {
      evt.preventDefault()

      window.dispatchEvent(new CustomEvent('sidebar:toggle', { bubbles: true, detail: { active: !this.isActive } }))
    }
  }

  toggle() {
    const isMobile = window.innerWidth < 769

    if (!isMobile) {
      return
    }

    if (this.isActive) {
      this.menuIcon?.classList.add('hidden')
      this.closeIcon?.classList.remove('hidden')
    } else {
      this.menuIcon?.classList.remove('hidden')
      this.closeIcon?.classList.add('hidden')
    }
  }
}

customElements.define('finesse-sidebar-button', FinesseSidebarButton)
